import React, { useState, useEffect } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import '../../styles/editModal.css';
import '../../styles/infographics.css';

// Публикация новости вместе с картинкой. Перенос ModalNewsRequest из приложения:
// для шаблонов 1, 4, 6 и 9 перед сохранением спрашивается комментарий, и вместе
// с картинкой в ленту уходит новость со ссылками на игроков или лигу.
// В приложении «Отмена» молча сохраняла картинку без новости — здесь это
// отдельная кнопка «Только скачать», чтобы разница была явной.
//props:
// open, onClose
// title — заголовок будущей новости (для превью админу)
// busy — идёт запрос
// onSubmit — (комментарий) опубликовать новость и скачать
// onSkip — скачать без новости

export default function NewsRequestModal({ open, onClose, title, busy, onSubmit, onSkip }) {
    const [comment, setComment] = useState('');

    useEffect(() => {
        if (open) setComment('');
    }, [open]);

    if (!open) return null;

    return (
        <div className="modalOverlay" onClick={busy ? undefined : onClose}>
            <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    <h2>Новость к картинке</h2>
                    <button className="modalClose" disabled={busy} onClick={onClose}>×</button>
                </div>

                <div className="modalBody">
                    <div className="seasonScopeNote">
                        <FiAlertCircle style={{ marginRight: '8px', flexShrink: 0 }} />
                        <span>
                            Вместе с картинкой в ленту приложения уйдёт новость
                            {title ? <> с заголовком «{title}»</> : null}. Ссылки на игроков
                            и лигу подставятся автоматически.
                        </span>
                    </div>

                    <label className="modalLabel">Комментарий</label>
                    <textarea
                        className="igTextarea"
                        rows={4}
                        value={comment}
                        placeholder="Текст новости"
                        disabled={busy}
                        onChange={(e) => setComment(e.target.value)}
                        autoFocus
                    />
                </div>

                <div className="modalFooter">
                    <button
                        className="igGhostBtn"
                        disabled={busy}
                        onClick={onSkip}
                    >
                        Только скачать
                    </button>
                    <button
                        className="igPrimaryBtn"
                        disabled={busy}
                        onClick={() => onSubmit(comment)}
                    >
                        {busy ? 'Публикуем…' : 'Опубликовать и скачать'}
                    </button>
                </div>
            </div>
        </div>
    );
}
